export const ModerationStatus = {
  APPROVED: 'APPROVED',
  UNMODERATED: 'UNMODERATED',
  REJECTED: 'REJECTED',
  // FLAGGED: 'FLAGGED',
}

// TODO Create Typescript Models and use in API repsonses
// export class Profile {
//     constructor(
//         slug: String,
//         name: String,
//         avatarUrl: String
//     ) { }
// }

// export class Company {
//     constructor(
//         slug: String,
//         thread: Number
//     ) { }
// }
